/**
 * Permite desplazar en horizontal un contenedor con la rueda vertical del ratón.
 * Solo actúa si el contenedor desborda y aún puede avanzar en esa dirección;
 * al llegar al extremo deja pasar el scroll vertical a la página/modal.
 */
const enableHorizontalWheelScroll = (el: HTMLElement): void => {
  el.addEventListener(
    "wheel",
    (ev: WheelEvent) => {
      if (Math.abs(ev.deltaY) <= Math.abs(ev.deltaX)) return;

      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0) return;

      const canScroll =
        (ev.deltaY < 0 && el.scrollLeft > 0) ||
        (ev.deltaY > 0 && el.scrollLeft < maxScroll - 1);
      if (!canScroll) return;

      ev.preventDefault();
      // Firefox puede reportar el delta en líneas en vez de píxeles
      el.scrollLeft += ev.deltaMode === 1 ? ev.deltaY * 16 : ev.deltaY;
    },
    { passive: false }
  );
};

export default enableHorizontalWheelScroll;
